import DeviceManager from '../utils/device-manager';
import FaqList from "./faq-list";

const SwiperMobile = {
    init () {
        this.useEvents = false;
        this.swiper = new Array();

        document.querySelectorAll('.js-swiper-mobile .swiper-container').forEach( ($swiper, index) => {
            this.swiper[index] = null;

            DeviceManager.addCallback(attr => {
                if (!this.swiper[index] && !DeviceManager.isGreaterThan(attr.current, 'lg')) { // CREATE SWIPER ON MOBILE
                    this.createSwiper( $swiper, index );
                    // console.log ('create > this.swiper['+ index + ']');
                } else if (this.swiper[index] && DeviceManager.isGreaterThan(attr.current, 'lg')) {
                    // console.log ('destroy > this.swiper['+ index + ']');
                    this.destroySwiper( index );
                }
            });
        });
    },

    createSwiper( el, i ) {
        let args = {
            slidesPerView: 1,
            spaceBetween: 60,
            threshold: 10,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            preventClicksPropagation: false,
            preventClicks: false,
        };

        const swiper = new Swiper(el, args);
        this.swiper[i] = swiper;
    },

    destroySwiper(i) {
        if (this.swiper[i]) {
            // console.log (i);
            this.swiper[i].destroy();
            this.swiper[i] = null;
        }
    }
}

export default SwiperMobile;